import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElIcons from '@element-plus/icons-vue'
import './assets/styles/global.css'
import _ from 'lodash'
import api from '@common/api'
import fetchs from '@common/request'


const app = createApp(App)

// 注册 Element Plus 图标
Object.keys(ElIcons).forEach(key => {
  app.component(key, ElIcons[key])
})

// 使用 Element Plus、Vuex 和 Vue Router
app.use(ElementPlus)
app.use(store)
app.use(router)

// 将 api 和 fetchs 挂载到 Vue 应用实例上
app.config.globalProperties.$api = api
app.config.globalProperties.$fetchs = fetchs
app.config.globalProperties.$lodash = _;
app.mount('#app')